module.exports = __webpack_public_path__ + "img/logo_new.380783c1.svg";